import {
  ClipboardIcon,
  HomeIcon,
  UserIcon,
  BookmarkIcon,
  MicrophoneIcon,
  BookOpenIcon,
  QuestionMarkCircleIcon,
  TicketIcon,
  ShoppingCartIcon,
  StarIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import { CourseName } from '../../api/utils/lms/utils';

const HOME_ITEMS = [
  {
    label: '과제 관리',
    key: 'assignment',
    icon: <ClipboardIcon className="h-6 w-6" />,
    children: [
      {
        label: <Link to={`./assignment/create`}>과제 내주기</Link>,
        key: 'assignment-create',
      },
      {
        label: <Link to={`./assignment/status`}>과제 현황보기</Link>,
        key: 'assignment-status',
      },
    ],
  },
  {
    label: 'AI인증제 관리',
    key: 'recitation',
    icon: <MicrophoneIcon className="h-6 w-6" />,
    children: [
      {
        label: <Link to={`./recitation/create`}>AI인증제 내주기</Link>,
        key: 'recitation-create',
      },
      {
        label: <Link to={`./recitation/status`}>AI인증제 현황보기</Link>,
        key: 'recitation-status',
      },
    ],
  },
  {
    label: <Link to={`./voucher`}>이용권 관리</Link>,
    key: 'voucher',
    icon: <TicketIcon className="h-6 w-6" />,
  },
];

const CHURCH_ITEMS = [
  {
    label: '과제 관리',
    key: 'assignment',
    icon: <ClipboardIcon className="h-6 w-6" />,
    children: [
      {
        label: <Link to={`./assignment/create`}>과제 내주기</Link>,
        key: 'assignment-create',
      },
      {
        label: <Link to={`./assignment/status`}>과제 현황보기</Link>,
        key: 'assignment-status',
      },
    ],
  },
  {
    label: <Link to={`./voucher`}>이용권 관리</Link>,
    key: 'voucher',
    icon: <TicketIcon className="h-6 w-6" />,
  },
  {
    label: <Link to={`./dalant`}>달란트 관리</Link>,
    key: 'dalant',
    icon: <StarIcon className="h-6 w-6" />,
  },
];

/**
 * 사이드 메뉴 리스트
 * @param courseType 현재 코스의 분류
 * @returns 사이드 메뉴 리스트
 */
export const getSidebarItems = (
  courseName: CourseName,
  handleClickLmsGuide: () => void,
) => [
  {
    label: <Link to={`./dashboard`}>클래스 홈</Link>,
    key: 'dashboard',
    icon: <HomeIcon className="h-6 w-6" />,
  },
  {
    label: (
      <Link
        to={`./take-class`}
        onClick={(event) => {
          if (!location.pathname.endsWith('/take-class')) return;

          event.preventDefault();
          window.location.reload();
        }}
      >
        수업자료 보기
      </Link>
    ),
    key: 'take-class',
    icon: <BookOpenIcon className="h-6 w-6" />,
  },
  ...(courseName === 'BASIC' ? HOME_ITEMS : []),
  ...(courseName === 'WMW' || courseName === 'HFHJ' ? CHURCH_ITEMS : []),
  {
    label: <Link to={`./membership-store`}>멤버십 스토어</Link>,
    key: 'membership-store',
    icon: <ShoppingCartIcon className="h-6 w-6" />,
  },
  // ...SidebarTodoList(menuExposure), // 코스 분류 별 할 일 관리 리스트 (영어교실 베이직 / 교회학교 HFHJ, WMW / 그 외)
  ...(courseName === 'BASIC' || courseName === 'WMW' || courseName === 'HFHJ'
    ? [
        {
          label: <Link to={`./student`}>학생 관리</Link>,
          key: 'student',
          icon: <UserIcon className="h-6 w-6" />,
        },
        {
          label: <Link to={`./class-group`}>반 관리</Link>,
          key: 'class-group',
          icon: <UserGroupIcon className="h-6 w-6" />,
        },
      ]
    : []),
  {
    label: <Link to={`./resources`}>자료실</Link>,
    key: 'resources',
    icon: <BookmarkIcon className="h-6 w-6" />,
  },
  {
    label: <Link to={`./dashboard`}>LMS 이용 가이드</Link>,
    key: 'lms-guide',
    icon: <QuestionMarkCircleIcon className="h-6 w-6" />,
    onClick: handleClickLmsGuide,
  },
];
